const CODE_TYPES = ["qrCode", "barcode39", "barcode128"];
const TEXT_TYPES = ["text", "textbox", "i-text"];

export const isCodeType = (type) => CODE_TYPES.includes(type);

const isTextElement = ({ type }) => !type || TEXT_TYPES.includes(type);

export const getBadgeTemplateTextFonts = (template) => {
  const elements = [
    ...(template?.fields || []),
    ...(template?.objects || []),
  ];

  return [
    ...new Set(
      elements
        .filter(isTextElement)
        .map(({ fontFamily }) =>
          typeof fontFamily === "string" ? fontFamily.trim() : ""
        )
        .filter(Boolean)
    ),
  ];
};

export const extractBadgeTemplate = (canvas, fields = {}) => {
  if (!canvas) {
    return { fields: [], objects: [] };
  }

  const savedObjects = canvas
    .getObjects()
    .filter(({ skipTemplateSave }) => !skipTemplateSave);

  const getScaledDimension = (dimension, scale = 1) =>
    typeof dimension === "number" ? dimension * scale : dimension;

  return savedObjects.reduce(
    (
      acc,
      {
        type,
        fontSize,
        scalingSetFontSize,
        fill,
        fontWeight,
        fontStyle,
        fontFamily,
        top,
        left,
        height,
        scaleY = 1,
        width,
        scaleX = 1,
        angle,
        id,
        textAlign,
        lineHeight,
        isLogo,
        codeType,
        imageUrl,
        text,
        value,
      },
      zIndex
    ) => {
      if (id) {
        const field = fields[id] || {};
        const fieldType = field.type || codeType || type;
        acc.fields.push({
          label: id,
          value: text ? text.replace(/ /g, "\u00A0") : field.value ?? value,
          type: fieldType,
          fontSize: isTextElement({ type: fieldType }) && scalingSetFontSize !== undefined
            ? scalingSetFontSize
            : fontSize,
          fill,
          fontWeight,
          fontStyle,
          fontFamily,
          top,
          left,
          height: getScaledDimension(height, scaleY),
          width: getScaledDimension(width, scaleX),
          angle,
          textAlign,
          zIndex,
          enabled: field.enabled !== false,
          ...(!isCodeType(fieldType) ? { imageUrl } : {}),
        });
      } else {
        const objectType = isLogo ? "logo" : codeType || type;
        acc.objects.push({
          type: objectType,
          fontSize: isTextElement({ type: objectType }) && scalingSetFontSize !== undefined
            ? scalingSetFontSize
            : fontSize,
          fill,
          fontWeight,
          fontStyle,
          fontFamily,
          top,
          left,
          height: getScaledDimension(height, scaleY),
          width: getScaledDimension(width, scaleX),
          angle,
          textAlign,
          lineHeight,
          zIndex,
          text: text ? text.replace(/ /g, "\u00A0") : text,
          ...(!isLogo && !isCodeType(objectType) ? { imageUrl } : {}),
          ...(isCodeType(objectType) && value !== undefined ? { value } : {}),
        });
      }
      return acc;
    },
    { fields: [], objects: [] }
  );
};
